var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"search-modal"}},[_c('searchBar',{on:{"result":_vm.getResult}}),(_vm.loading)?_c('div',{staticClass:"search-result"},[_c('loading')],1):_vm._e(),_c('searchResult',{attrs:{"results":_vm.results}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }